import { balanceText } from 'balanced-text'

const $ = window.jQuery;


const BalanceText = {

    init() {
    

         /*    balanceText($('h1'));  */

    },


};

export default BalanceText;